var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        title: "",
        subtitle: "",
        breadcrumbs: _vm.breadcrumbs,
        helpForm: false,
        guest: _vm.guest || _vm.user,
        location: _vm.user?.selected_location || _vm.guest?.location,
      },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0",
          attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "FormTitle",
                { staticClass: "pa-4 pt-0", attrs: { dark: "" } },
                [_vm._v("Checkout")]
              ),
              _vm._v(" "),
              _c("ShoppingCartItems", {
                ref: "items",
                attrs: {
                  user: _vm.user,
                  guest: _vm.guest,
                  errors: _vm.errors,
                  items: _vm.items,
                },
                on: {
                  update: function ($event) {
                    return _vm.updateItem($event)
                  },
                  delete: function ($event) {
                    return _vm.deleteItem($event)
                  },
                  clear: function ($event) {
                    return _vm.clearCart()
                  },
                  viewContract: function ($event) {
                    _vm.viewContracts = true
                  },
                },
              }),
              _vm._v(" "),
              _vm.items.length
                ? _c("ShoppingCartPayment", {
                    ref: "payment",
                    attrs: {
                      user: _vm.user,
                      guest: _vm.guest,
                      errors: _vm.errors,
                      items: _vm.items,
                      subtotal: _vm.subtotal,
                    },
                    on: {
                      applyPromo: function ($event) {
                        return _vm.applyPromo($event)
                      },
                      applyGift: function ($event) {
                        return _vm.applyGift($event)
                      },
                      stripeLoaded: function ($event) {
                        _vm.stripeLoaded = true
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "validate",
                          fn: function () {
                            return [
                              false
                                ? _c("v-input", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "hide-details": "auto",
                                      value: _vm.form.paymentMethod,
                                      rules: [
                                        (val) =>
                                          val !== null ||
                                          !_vm.totalAmountDue ||
                                          "A payment method is required",
                                      ],
                                      "error-messages": _vm.form.paymentMethod,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2852843331
                    ),
                    model: {
                      value: _vm.form.paymentMethod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paymentMethod", $$v)
                      },
                      expression: "form.paymentMethod",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.items.length
                ? _c("ShoppingCartSummary", {
                    ref: "summary",
                    attrs: {
                      user: _vm.user,
                      guest: _vm.guest,
                      errors: _vm.errors,
                      items: _vm.items,
                      subtotal: _vm.subtotal,
                      totalAmountDue: _vm.totalAmountDue,
                      autoCoupons: _vm.autoCoupons,
                      appliedGift: _vm.form.appliedGift,
                      appliedPromo: _vm.form.appliedPromo,
                      appliedBalance: _vm.getAppliedBalance,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "submit",
                          fn: function () {
                            return undefined
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3661598429
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.viewContracts && !_vm.hasUnsignedContracts
                ? _c("FormSubmit", {
                    attrs: {
                      dark: "",
                      type: "submit",
                      loading: _vm.loading,
                      valid: _vm.valid && !!_vm.items.length,
                      errors: _vm.errors,
                      gradient: "gradient-orange",
                      icon: "",
                      text: `Pay ${_vm.formatUnitAmount(_vm.totalAmountDue)}`,
                      disabled: !_vm.stripeLoaded,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.guest?.location?.isOpen === false
                ? _c("p", { staticClass: "py-2" }, [
                    _vm._v(
                      "\n                Fully refundable until your first lesson or class\n            "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasUnsignedContracts
            ? _c("FormSubmit", {
                attrs: {
                  dark: "",
                  valid: "",
                  loading: _vm.loading,
                  errors: _vm.errors,
                  gradient: "gradient-orange",
                  icon: "",
                  text: "Review Agreements",
                },
                on: {
                  submit: function ($event) {
                    _vm.viewContracts = true
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewContracts
        ? _c("ShoppingCartContracts", {
            attrs: {
              items: _vm.items,
              errors: _vm.errors,
              user: _vm.user,
              guest: _vm.guest,
              routeName: "shoppingCart.storeContract",
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.viewContracts = false))
              },
              success: function ($event) {
                _vm.closeModal(
                  () => (_vm.viewContracts = false),
                  (_vm.$refs.layout.showMessage = true)
                )
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.registrationAlert
        ? _c("SoliChoice", {
            attrs: {
              title: "Edit Registration?",
              subtitle:
                "This shopping cart item is an event registration. Continue to registration page?",
              button1: "Continue",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                _vm.$inertia.get(
                  _vm.route("eventRegistration.create", {
                    eventRegister: _vm.registrationAlert,
                  })
                )
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.registrationAlert = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }